<template>
	<HeaderPopup
		class="currency-select-component"
		:is-open="isOpen"
		side="bottom"
		align="end"
		:offset="4"
		@close="isOpen = false"
	>
		<template #trigger>
			<div
				class="trigger"
				:class="$attrs.class"
				@mouseenter="onMouseEnter"
				@mouseleave="onMouseLeave"
			>
				<span class="selected-currency-symbol">{{ selectedCurrency?.symbol }}</span>
				<span class="selected-currency-code">
					{{ selectedCurrency?.code }}
				</span>
			</div>
		</template>

		<template #default>
			<div
				class="currency-select-popup"
				@mouseenter="onMouseEnter"
				@mouseleave="onMouseLeave"
			>
				<div class="currency-select-popup-header">
					Валюта предложений
				</div>

				<div class="currency-select-popup-list">
          <button
            v-for="item in allCurrencies"
            :key="item.code"
            :disabled="!item.readyForUse"
            :class="getItemClass(item)"
            @click="setUserCurrency(item)"
          >
            <template v-if="item.courseTo">
              <span class="course-from">{{ item.courseFrom }}</span>
              <span class="course-sign">≈</span>
              <span class="course-to">{{ item.courseTo }}</span>
            </template>
            <template v-else>
              <span class="course-plain">{{ item.courseFrom }}</span>
            </template>

            <span class="title">{{ item.title }}</span>
          </button>
				</div>

				<div
					v-if="courseDate"
					class="currency-select-popup-footer"
				>
					Используется курс ЦБ РФ от {{ courseDate.format() }}
				</div>
			</div>
		</template>
	</HeaderPopup>
</template>

<style lang="scss" src="./AppCurrencySelect.scss"/>

<script lang="ts">

import VIcon       from '@/lib/components/VIcon/VIcon.vue';
import HeaderPopup from '@/lib/components/AppHeader/HeaderPopup/HeaderPopup.vue';

export default defineComponent({
	name: 'AppCurrencySelect',

	components: { VIcon, HeaderPopup },

	inheritAttrs: false,

	data() {
		return {
			isOpen:     false,
			closeTimer: null,
		};
	},

	computed: {
    allCurrencies() {
      const localCurrency = this.$core.currentPartner.country.localCurrency;

      return Array.from(this.$core.currencies.currencies.values()).map(currency => {
        const isSettlement = currency.code === localCurrency.code;
        const hasRate      = currency.rate && !currency.rate.isEmpty();
        let courseFrom;
        let courseTo;

        if (isSettlement) {
          courseFrom = 'Валюта расчета';
          courseTo   = null;
        }
        else if (hasRate) {
          courseFrom = `1,00 ${currency.symbol}`;
          courseTo   = `${currency.rate.format()} ${localCurrency.symbol}`;
        }
        else {
          courseFrom = 'В разработке';
          courseTo   = null;
        }

        return {
          title:       currency.description,
          code:        currency.code,
          courseFrom:  courseFrom,
          courseTo:    courseTo,
          readyForUse: isSettlement || hasRate,
        };
      });
    },

		selectedCurrency() {
			return this.$core.currencies.currencies.get(
				this.$core.displayedCurrencyCode
			);
		},

		courseDate() {
			let courseDate = null;

			Array.from(this.$core.currencies.currencies.values()).forEach(currency => {
				if (courseDate === null && currency.rateDate instanceof Date) {
					courseDate = currency.rateDate;
				}
			});

			return courseDate;
		},
	},

	methods: {
		onMouseEnter() {
			clearTimeout(this.closeTimer);
			this.isOpen = true;
		},

		onMouseLeave() {
			this.closeTimer = setTimeout(() => {
				this.isOpen = false;
			}, 200); // задержка перед закрытием попрапа - т.к. offset="4" создаёт 4px дырку между триггером и попапом
		},

		getItemClass(item) {
			return {
				selected: item.code === this.selectedCurrency.code,
			};
		},

		async setUserCurrency(currency) {
			await this.$core.acl.updateDisplayedCurrencyCode(currency.code);
			this.isOpen = false;
		},
	},
});
</script>
